/** One line under the exception-reason body. Stamp is already formatted. */
export const exceptionReasonAttribution = (
  personName: string | null | undefined,
  stamp: string | null | undefined
): string | null => {
  const name = personName?.trim() ?? "";
  const at = stamp?.trim() ?? "";
  if (name && at) {
    return `Entered by ${name} · ${at}`;
  }
  if (name) {
    return `Entered by ${name}`;
  }
  if (at) {
    return `Entered ${at}`;
  }
  return null;
};
